module.exports = __webpack_public_path__ + "img/default-btn-vi.c99cae3e.png";